/** @format */

import {
  Chk,
  Feature,
  Logging,
  Loyalty,
  MyAccount,
  Pricing,
  Tests,
} from './environment-common-config.interface';

import { API } from './environment-api.interface';
import { ApiTokens } from './environment-api-tokens.interface';
import { BaseUrls } from './environment-base-urls.interface';
import { LaunchConfig } from './launch-config.interface';
import { ThirdParty } from './environment-third-party.interface';

export interface IEnvironment {
  api: API;

  apiAuthKeys?: {
    partnerKey: string;
    secretKey: string;
  };
  apiTokens: ApiTokens;
  baseDomain?: Record<string, string>;
  baseUrls?: BaseUrls;
  captchaSiteKey?: string;
  catOvrGrpId: Record<string, string>;
  chk?: Chk;
  customizer: string;
  dataFiles: unknown;
  defaultActiveCloudProvider: string;
  environmentName?: string;
  esbEnvironmentHeader: string;
  feature: Feature;
  handshakesParams?: Record<string, string>;
  identityServiceKey?: {
    partnerKey: string;
    secretKey: string;
  };
  imagePresets?: boolean;
  inventory: Record<string, number>;
  isLocal?: boolean;
  // Killswitches in clp have explicit structure than interface.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  killSwitch?: any;
  launchConfig?: LaunchConfig;
  liveChatLinks?: Record<string, string>;
  logging: Logging;
  loyalty?: Loyalty;
  myAccount?: MyAccount;
  offerDate?: {
    endDateString: string;
    startDateString: string;
  };
  partyAuthKeys?: {
    partnerKey: string;
    secretKey: string;
  };
  platform?: {
    forwardedHeadersMatchers?: RegExp[];
  };
  previewLinks?: boolean;
  pricing?: Pricing;
  production: boolean;
  searchbyTermTypeParam: string;
  simpleHeaderLogoUrl?: {
    prod: Record<string, string>;
    nonProd: Record<string, string>;
  };
  solePanel?: {
    dsg: string;
    gg: string;
    iframeParent: string;
    mj?: string;
    pl: string;
  };
  tests?: Tests;
  thirdParty: ThirdParty;
  trackOrders?: boolean;
  useRedis?: boolean;
  echt?: {
    dsg: string;
    gg: string;
    g3: string;
    pl: string;
  };
}

export class Environment implements IEnvironment {
  declare api: API;
  declare apiAuthKeys?: {
    partnerKey: string;
    secretKey: string;
  };

  declare apiTokens: ApiTokens;
  declare baseUrls: BaseUrls;
  declare catOvrGrpId: Record<string, string>;
  declare customizer: string;
  declare dataFiles: unknown;
  declare defaultActiveCloudProvider: string;
  declare environmentName?: string;
  declare esbEnvironmentHeader: string;
  declare inventory: Record<string, number>;
  declare chk?: Chk;
  declare logging: Logging;
  declare myAccount: MyAccount;
  declare loyalty: Loyalty;
  declare pricing: Pricing;
  declare production: boolean;
  declare searchbyTermTypeParam: string;
  declare thirdParty: ThirdParty;
  declare feature: Feature;
  // Killswitches in clp have explicit structure than interface.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  declare killSwitch?: any;
  declare imagePresets: boolean;
  declare useRedis: boolean;
  declare previewLinks: boolean;
  declare tests?: Tests;
  declare launchConfig?: LaunchConfig;
  declare handshakesParams?: Record<string, string>;
  declare baseDomain?: Record<string, string>;
  declare trackOrders?: boolean;
  declare echt?: {
    dsg: string;
    gg: string;
    g3: string;
    pl: string;
  };

  identityServiceKey?: {
    partnerKey: string;
    secretKey: string;
  };

  creditServiceKey?: {
    partnerKey: string;
    secretKey: string;
  };

  offerDate?: {
    endDateString: string;
    startDateString: string;
  };

  scorecardPlus?: {
    fallbackImageIdentifier: string;
  };

  declare partyAuthKeys?: {
    partnerKey: string;
    secretKey: string;
  };

  public isLocal = false;
  declare solePanel?: {
    dsg: string;
    gg: string;
    iframeParent: string;
    mj: string;
    pl: string;
  };

  declare liveChatLinks?: Record<string, string>;

  declare platform?: {
    forwardedHeadersMatchers?: RegExp[];
  };

  declare simpleHeaderLogoUrl?: {
    prod: Record<string, string>;
    nonProd: Record<string, string>;
  };
}
